import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../pages/HomePage.vue'),
  },
  {
    path: '/:clinicName',
    name: 'Clinic',
    component: () => import('../pages/ClinicPage.vue'),
    props: true,
  },
  {
    path: '/:clinicName/sucesso',
    name: 'Success',
    component: () => import('../pages/SuccessPage.vue'),
    props: true,
  },
  {
    path: '/:clinicName/erro',
    name: 'Error',
    component: () => import('../pages/ErrorPage.vue'),
    props: true,
  },
  {
    path: '/:clinicName/expirado',
    name: 'Expired',
    component: () => import('../pages/ExpiredPage.vue'),
    props: true,
  },
  {
    path: '/:clinicName/:idRemoto',
    name: 'ClinicCliente',
    component: () => import('../pages/ClinicPage.vue'),
    props: true,
  },
  {
    path: '/nao-encontrado',
    name: 'NaoEncontrado',
    component: () => import('../pages/NaoEncontrado.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
